<template>
  <div class="text-align-left" v-if="this.$store.get('systems@ApiKey')">
    <b-alert show variant="dark">
      <h4>แพทย์ : {{ this.$store.get("systems@LoginData").userName }}</h4>
      <div>
        <b-form-select
          v-model="dchStatusSelect"
          :options="dchStatus"
        ></b-form-select>
      </div>
      <div v-if="!this.tbDoctorSumWardTableData">
        <md-toolbar class="md-accent">
          <h3 class="md-title">คุณไม่ได้เป็นแพทย์เจ้าของไข้ !</h3>
        </md-toolbar>
      </div>

      <div role="tablist">
        <b-card
          no-body
          class="mb-1 card-custom"
          v-for="item in tbDoctorSumWardTableData"
          v-bind:key="item.id"
        >
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              @click="selectWardData2(item.ward, item.ward_name)"
              variant="info"
              class="text-align-left"
              >{{ item.ward_name }} ({{
                Number(item.InchargeDoctor) + Number(item.JoinDoctor)
              }})</b-button
            >
          </b-card-header>
          <b-collapse
            :id="'doctor-sum-ward-' + item.ward"
            accordion="my-doctor-sum-ward"
            role="tabpanel"
          >
            <b-card-body>
              <b-card-text v-if="selectWard == item.ward">
                <DoctorPatientWard
                  v-bind:select-ward="selectWard"
                  v-bind:select-doctor="selectDoctor"
                  v-bind:dch-status="dchStatusSelect"
                ></DoctorPatientWard>
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>

      <div v-if="false">
        <b-table
          striped
          hover
          small
          :items="this.tbDoctorSumWardTableData"
          :fields="this.tbDoctorSumWardTableFieldsData"
          :sort-by.sync="sortBy"
          :sort-asc.sync="sortDesc"
          class="font13px"
          responsive
        >
          <template v-slot:cell(actions)="row">
            <div @click="selectWardData(row.item.ward, row.item.ward_name)">
              <v-icon
                name="file-text"
                class="icon-custom1 cursor-pointer font-color2"
              ></v-icon>
            </div>
          </template>
        </b-table>
      </div>
    </b-alert>
    <b-modal
      id="modal-doctor-patient-ward"
      :title="'ผู้ป่วยใน Ward : ' + this.selectWardName"
      size="xl"
      hide-footer
      button-size="sm"
      :no-close-on-backdrop="true"
      :close-on-esc="true"
    >
      <!-- 
      <div class="margin-bottom">
        <DoctorPatientWard
          v-bind:select-ward="this.selectWard"
          v-bind:select-doctor="this.selectDoctor"
          v-bind:dch-status="this.dchStatusSelect"
        ></DoctorPatientWard>
      </div>
      -->

      <b-row>
        <b-col lg="12">
          <div class="d-block text-center">
            <b-button
              size="sm"
              class="d-print-none"
              @click="$bvModal.hide('modal-doctor-patient-ward')"
              >Close</b-button
            >
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { Component, Vue, options } from "vue-property-decorator";
import feather from "vue-icon";
import store from "@/store/store";
import axios from "axios";
import thaiDatetime from "@/functions/thaiDatetime";
import pjFunctions from "@/functions/pjFunctions";
import DoctorPatientWard from "@/components/IPDs/RoundWard/DoctorPatientWard";

import PatientAdmitDischargeType from "@/models/patientEMRs/PatientAdmitDischargeType";
import PatientAdmitDischargeStatus from "@/models/patientEMRs/PatientAdmitDischargeStatus";

Vue.component("DoctorPatientWard", DoctorPatientWard);

@Component({
  component: {
    store,
    axios,
    thaiDatetime,
    pjFunctions,
    DoctorPatientWard,
    PatientAdmitDischargeType,
    PatientAdmitDischargeStatus
  },
  data() {
    return {
      thaiDatetimeFc: null,
      pjFunctionsFc: null,
      lang: {
        // days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        days: ["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"],
        months: [
          "ม.ค",
          "ก.พ",
          "มี.ค",
          "เม.ย",
          "พ.ค",
          "มิ.ย",
          "ก.ค",
          "ส.ค",
          "ก.ย",
          "ต.ค",
          "พ.ย",
          "ธ.ค"
        ],
        // months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        pickers: ["next 1 days", "previous 1 days"],
        placeholder: {
          date: "Select Date",
          dateRange: "Select Date Range"
        }
      },
      sortBy: "numbers",
      sortDesc: true,
      tbDoctorSumWardTableData: null,
      tbDoctorSumWardTableFieldsData: null,
      selectWard: "",
      selectWardName: "",
      selectDoctor: "",
      dchStatusSelect: "N",
      dchStatus: [
        { value: "N", text: "ผู้ป่วย Admit ปัจจุบัน" },
        { value: "Y", text: "ผู้ป่วย Discharge ย้อนหลัง 14 วัน" }
      ]
    };
  },
  mounted() {},
  created() {
    this.thaiDatetimeFc = thaiDatetime.methods;
    this.pjFunctionsFc = pjFunctions.methods;
    this.setDoctorSumWardData();
  },
  watch: {
    dchStatusSelect: function() {
      this.setDoctorSumWardData();
    }
  },
  methods: {
    show(group, type = "", title = "", text = "") {
      this.$notify({
        group,
        title: title,
        text: text,
        type,
        data: {
          randomNumber: Math.random()
        }
      });
    },
    clean(group) {
      this.$notify({ group, clean: true });
    },
    setDoctorSumWardData() {
      let formData = new FormData();
      formData.append("CompanyId", this.$store.get("systems@CompanyId"));
      formData.append("ApiKey", this.$store.get("systems@ApiKey"));
      formData.append(
        "DoctorCode",
        this.$store.get("systems@LoginData").DoctorCode
      );

      let data = [];

      let ScrObj = this;
      this.axios
        .post(
          this.$store.get("systems@UrlApi") + "EnquireIPDDoctorSumWard",
          formData
        )
        .then(function(response) {
          ScrObj.output = response.data;
          if (ScrObj.output.status === true) {
            data = [];

            for (var val of ScrObj.output.result) {
              if (
                ScrObj.dchStatusSelect != "Y" &&
                (val.NoPtInchargeDoctor > 0 || val.NoPtJoinDoctor > 0)
              ) {
                data.push({
                  ward: val.ActiveWard,
                  ward_name: val.ActiveWardName,
                  InchargeDoctor: val.NoPtInchargeDoctor,
                  JoinDoctor: val.NoPtJoinDoctor
                });
              } else {
                if (
                  val.NoPtInchargeDoctorDCH > 0 ||
                  val.NoPtJoinDoctorDCH > 0
                ) {
                  data.push({
                    ward: val.ActiveWard,
                    ward_name: val.ActiveWardName,
                    InchargeDoctor: val.NoPtInchargeDoctorDCH,
                    JoinDoctor: val.NoPtJoinDoctorDCH
                  });
                }
              }
            }

            let DoctorSumWardTableFieldsData = [
              { label: "Ward", key: "ward", sortable: true },
              { label: "Ward Name", key: "ward_name", sortable: true },
              {
                label: "แพทย์เจ้าของไข้",
                key: "InchargeDoctor",
                sortable: true
              },
              { label: "แพทย์ร่วม", key: "JoinDoctor", sortable: true },
              { label: "View", key: "actions", class: "text-center" }
            ];

            ScrObj.tbDoctorSumWardTableData = data;
            ScrObj.tbDoctorSumWardTableFieldsData = DoctorSumWardTableFieldsData;
          } else {
            ScrObj.tbDoctorSumWardTableData = null;
            ScrObj.tbDoctorSumWardTableFieldsData = null;
            // ScrObj.setBTR(ScrObj.MyHn, ScrObj.MyVn);
          }
        })
        .catch(function(error) {
          ScrObj.output = error;
          ScrObj.tbDoctorSumWardTableData = null;
          ScrObj.tbDoctorSumWardTableFieldsData = null;
          console.log("EnquireIPDDoctorSumWard : " + ScrObj.output);
        });

      // #### Admit Discharge TypeData Load ####
      let DataLoadObj = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "AdmitDischargeTypeData", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey")
        })
        .then(function(response) {
          DataLoadObj.output = response.data;
          if (DataLoadObj.output.status === true) {
            PatientAdmitDischargeType.delete({
              where(record) {
                return record.id != "";
              }
            });

            data = [];
            for (var val of DataLoadObj.output.result) {
              data.push({
                id: val.dchtype,
                dchtype: val.dchtype,
                name: val.name,
                datas: val
              });
            }

            PatientAdmitDischargeType.insertOrUpdate({
              data
            });
          } else {
            // console.log('AdmitDischargeTypeData : '+DataLoadObj.output.ErrorMessage)
          }
        })
        .catch(function(error) {
          DataLoadObj.output = error;
          console.log("AdmitDischargeTypeData : " + DataLoadObj.output);
        });

      // #### Admit Discharge Status Data Load ####
      this.axios
        .post(this.$store.get("systems@UrlApi") + "AdmitDischargeStatusData", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey")
        })
        .then(function(response) {
          DataLoadObj.output = response.data;
          if (DataLoadObj.output.status === true) {
            PatientAdmitDischargeStatus.delete({
              where(record) {
                return record.id != "";
              }
            });

            data = [];
            for (var val of DataLoadObj.output.result) {
              data.push({
                id: val.dchstts,
                dchstts: val.dchstts,
                name: val.name,
                datas: val
              });
            }

            PatientAdmitDischargeStatus.insertOrUpdate({
              data
            });
          } else {
            // console.log('AdmitDischargeStatusData : '+DataLoadObj.output.ErrorMessage)
          }
        })
        .catch(function(error) {
          DataLoadObj.output = error;
          console.log("AdmitDischargeStatusData : " + DataLoadObj.output);
        });
    },
    selectWardData(ward, ward_name) {
      this.selectWard = ward;
      this.selectWardName = ward_name;
      this.selectDoctor = this.$store.get("systems@LoginData").DoctorCode;
      setTimeout(() => {
        this.$bvModal.show("modal-doctor-patient-ward");
      }, 500);
    },
    selectWardData2(ward, ward_name) {
      this.selectWard = ward;
      this.selectWardName = ward_name;
      this.selectDoctor = this.$store.get("systems@LoginData").DoctorCode;
      setTimeout(() => {
        this.$root.$emit("bv::toggle::collapse", "doctor-sum-ward-" + ward);
      }, 500);
    }
  }
})
export default class DoctorSumWard extends Vue {}
</script>


<style lang="scss">
</style>
